import React, { Component } from 'react';

import { Spinner } from 'reactstrap';
<Spinner color="primary" />
class Loader extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Spinner color="primary" />
        );
    }
}

export default Loader;
